import { ROW_KEY, DATA_PRIMARY_KEY } from './constants'
import { v4 as uuid } from 'uuid'

export default function injectRowKey (rowStore) {
  if (!rowStore.getValue(ROW_KEY)) {
    rowStore.setValue(ROW_KEY, rowStore.getValue(DATA_PRIMARY_KEY) || uuid())
  }
}
